import React, { useState } from "react";
import { Dropdown, Stack, IDropdownOption, Text, TextField } from "@fluentui/react";
import { Mapping } from "../../models";

export interface LogoutLinkGenerationProps {
    mappings: Mapping[];
};

const LogoutLinkGeneration: React.FC<LogoutLinkGenerationProps> = props => {

    const [selectedKey, setSelectedKey] = useState("/");

    const options = props.mappings.map((mapping): IDropdownOption => ({
        key: mapping.relativeUrl,
        text: mapping.relativeUrl
    }));

    return (
        <Stack>
            <Stack horizontal tokens={{childrenGap: 10}}>
                <Text>Chcę, aby po wylogowaniu nastąpiło przekierowanie na raport</Text>
                <Dropdown options={options} selectedKey={selectedKey} placeholder="/" dropdownWidth="auto" onChange={(_, option) => setSelectedKey(option.key as string)} />
            </Stack>
            <TextField readOnly label="Link do wylogowania" value={`${window.location.origin}/global-logout?postLogoutRedirectUri=` + encodeURIComponent(options.find(option => option.key === selectedKey)?.text ?? "/")} />
        </Stack>
    );
};

export default LogoutLinkGeneration;
